<script lang="ts">
	import HDPlayoffs from '#lib/hockeydata/components/HDPlayoffs.svelte';

	const { data } = $props();
</script>

<h2 class="mb-3">Playoffs</h2>
<HDPlayoffs season={data.season} />
